// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2006":"c9dac2cf1851aa41","2890":"9cca8763c500cf67","6793":"7a55cdf94fc5b8c7","9625":"e2e317741005fdb9"}[chunkId] + ".js";
};